import {
  AlertOutlined,
  AppstoreOutlined,
  BellOutlined,
  CheckSquareOutlined,
  ContactsOutlined,
  ClearOutlined,
  ControlOutlined,
  DeploymentUnitOutlined,
  ExperimentOutlined,
  FileTextOutlined,
  FireOutlined,
  MedicineBoxOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  IdcardOutlined,
  ImportOutlined,
  MergeCellsOutlined,
  PhoneOutlined,
  RobotOutlined,
  ScanOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import type { SectionItem } from '../components/SectionLayout';

export const SETTINGS_SECTIONS: SectionItem[] = [
  { path: '/settings/general', label: 'General', icon: <SettingOutlined />, superAdminOnly: true },
  { path: '/settings/users', label: 'Users', icon: <TeamOutlined />, superAdminOnly: true },
  { path: '/settings/features', label: 'Features', icon: <ExperimentOutlined />, superAdminOnly: true },
  { path: '/settings/notifications', label: 'Notifications', icon: <BellOutlined />, superAdminOnly: true },
  { path: '/settings/projects', label: 'Projects', icon: <AppstoreOutlined /> },
  { path: '/settings/fields', label: 'Fields', icon: <ControlOutlined /> },
  { path: '/settings/pipelines', label: 'Pipelines', icon: <DeploymentUnitOutlined />, feature: 'pipelines' },
  { path: '/settings/domains', label: 'Email domains', icon: <GlobalOutlined /> },
  { path: '/settings/agents', label: 'Agents', icon: <RobotOutlined /> },
  { path: '/settings/warmup', label: 'Email warm-up', icon: <FireOutlined /> },
];

export const TOOLS_SECTIONS: SectionItem[] = [
  { path: '/tools/scan-cards', label: 'Scan cards', icon: <ScanOutlined />, feature: 'cardScanner', phoneFullScreen: true },
  { path: '/tools/verification', label: 'Verification', icon: <SafetyCertificateOutlined /> },
  { path: '/tools/warmup', label: 'Email warm-up', icon: <FireOutlined /> },
  { path: '/tools/domain-health', label: 'Domain health', icon: <MedicineBoxOutlined /> },
  { path: '/tools/imports', label: 'Importer', icon: <ImportOutlined /> },
  { path: '/tools/notes-import', label: 'Notes importer', icon: <FileTextOutlined /> },
  { path: '/tools/asana-import', label: 'Asana importer', icon: <CheckSquareOutlined />, feature: 'tasks' },
  { path: '/tools/duplicates', label: 'Duplicates', icon: <MergeCellsOutlined /> },
  { path: '/tools/name-cleanup', label: 'Name clean up', icon: <ClearOutlined /> },
  { path: '/tools/odd-contacts', label: 'Odd contacts', icon: <AlertOutlined /> },
  { path: '/tools/email-phone-cleaner', label: 'Email & Phone Cleaner', icon: <IdcardOutlined /> },
  { path: '/tools/duplicate-phones', label: 'Duplicate Phones', icon: <PhoneOutlined /> },
  { path: '/tools/address-merger', label: 'Address Merger', icon: <EnvironmentOutlined /> },
  { path: '/tools/no-contact-info', label: 'No contact info', icon: <ContactsOutlined /> },
];
